export default __webpack_public_path__ + "static/media/cart-img.f4db3ff2.png";